function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgImoveis = function SvgImoveis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.011 20.427v-7.608l-.385-.069c-1.86-.328-2.394-2.74-.847-3.822l9.07-6.351a2.12 2.12 0 012.951.52l6.351 9.07c.868 1.24.184 2.884-1.15 3.258v5.002c0 1.002-.776 1.825-1.749 1.825H5.761c-.973 0-1.75-.823-1.75-1.825zm14.99-5.904l.478-.021c.856-.037 1.362-1.033.853-1.76L13.98 3.67a1.12 1.12 0 00-1.559-.275l-9.07 6.351c-.817.572-.534 1.845.448 2.019l1.211.213v8.448c0 .462.343.825.75.825h1.536l1.28-7.242a2 2 0 012.316-1.623l2.955.522a2 2 0 011.622 2.317l-1.064 6.025h3.846c.407 0 .749-.362.749-.824v-5.904zm-4.516.53l-1.094 6.197H8.313l1.249-7.067a1 1 0 011.158-.81l2.955.52a1 1 0 01.81 1.16z",
    fill: props.color
  }));
};

SvgImoveis.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgImoveis.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgImoveis;